import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useGoalFormContext } from './goalFormState';
import { ObjectiveFormData } from './types';

type Props = {
  disabled?: boolean;
};

export const GoalSaveButton: React.FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { isSubmitting } = useGoalFormContext<ObjectiveFormData>();
  const isDisabled = disabled || isSubmitting;

  return (
    <Button type="submit" className="w-100" disabled={isDisabled}>
      {isSubmitting && (
        <Spinner size="sm" animation="border" className="me-2" />
      )}
      {t('form.general.saveButton')}
    </Button>
  );
};
